module.exports = __webpack_public_path__ + "img/home_chart_ru.ce092a3.png";